import { withI18n } from '@lingui/react'
import { arrayOf, bool, shape, string } from 'prop-types'

import SliderHorizontal from 'views/components/organisms/SliderHorizontal'
import HorizontalSliderItem from 'views/components/organisms/SliderHorizontal/ProductSliderItem'
import { i18nType, ProductType } from 'views/utils/propTypes'
import { adServerMetadata } from 'views/utils/propTypes/adserver'

const handler = () => undefined

const renderItems = (
  products,
  lazyLoadAll,
  showBuyButton,
  noSlider,
  queryId,
  enableSponsoredLabel,
  metadata
) =>
  products.map((product, idx) => (
    <HorizontalSliderItem
      product={product}
      onClick={handler}
      index={idx}
      lazyLoad={lazyLoadAll || null}
      showBuyButton={showBuyButton}
      noSlider={noSlider}
      queryId={queryId}
      enableSponsoredLabel={enableSponsoredLabel}
      metadata={metadata}
    />
  ))

const ProductSlider = props => {
  const {
    i18n,
    products,
    headline,
    headlineIsHtml,
    lazyLoadAll,
    showBuyButton,
    noSlider,
    queryId,
    enableSponsoredLabel,
    metadata,
    ...rest
  } = props

  const items = renderItems(
    products,
    lazyLoadAll,
    showBuyButton,
    noSlider,
    queryId,
    enableSponsoredLabel,
    metadata
  )
  const title =
    headline || i18n._('productSliders.recommendedProducts.headline')

  return (
    <SliderHorizontal
      items={items}
      title={title}
      titleIsHtml={headline && headlineIsHtml}
      adaptableArrows
      noSlider={noSlider}
      {...rest}
    />
  )
}

ProductSlider.propTypes = {
  ...SliderHorizontal.propTypes,
  enableSponsoredLabel: bool,
  i18n: i18nType.isRequired,
  products: arrayOf(shape(ProductType)).isRequired,
  headline: string,
  headlineIsHtml: bool,
  target: string,
  lazyLoadAll: bool,
  queryId: string,
  metadata: adServerMetadata,
}

ProductSlider.defaultProps = {
  enableSponsoredLabel: false,
  visibleItemCount: 3,
  headline: null,
  headlineIsHtml: false,
  target: null,
  lazyLoadAll: false,
  queryId: null,
}

export default withI18n()(ProductSlider)
